<template>
	<div>
		<v-container>
			<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>

			<v-stepper v-model="step" :alt-labels="$vuetify.breakpoint.mdAndDown">
				<v-stepper-items>
					<v-stepper-content step="1">
						<v-form v-model="valid">
							<v-row no-gutters>
								<v-col cols="12" md="6">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2">
											<v-select
												v-model="mediaType"
												outlined
												hide-details="auto"
												label="نوع المحتوى"
												:items="mediaTypes"
												item-text="name"
												item-value="value"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-autocomplete
												v-model="selectedRecord"
												outlined
												hide-details="auto"
												label="المحتوى"
												:items="records"
												item-text="title"
												return-object
												:rules="[rules.required]"
											></v-autocomplete>
										</v-col>
										<v-col v-if="selectedRecord" cols="12" class="pa-2">
											<v-text-field
												v-model="selectedRecord.title"
												outlined
												hide-details="auto"
												label="العنوان"
												:rules="[rules.required, rules.maxLength75]"
											></v-text-field>
										</v-col>
										<v-col v-if="selectedRecord" cols="12" class="pa-2">
											<v-textarea
												v-model="selectedRecord.description"
												outlined
												hide-details="auto"
												label="الوصف"
												:rules="[rules.maxLength250]"
											></v-textarea>
										</v-col>
										<v-col v-if="selectedRecord" cols="12" class="pa-2">
											<v-text-field
												v-model="selectedRecord.url"
												outlined
												hide-details="auto"
												label="الرابط"
												disabled
												:rules="[rules.required]"
											></v-text-field>
										</v-col>
										<v-col v-if="selectedRecord" cols="12" class="pa-2">
											<v-select
												v-model="order"
												outlined
												hide-details="auto"
												label="الترتيب"
												:items="orders"
												:rules="[rules.required]"
											></v-select>
										</v-col>
										<v-col v-if="selectedRecord" cols="12" class="pa-2 text-center">
											<v-avatar color="grey lighten-5" height="150" tile :width="300" class="mt-1">
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="selectedRecord.coverPic"
													:aspect-ratio="2"
												></v-img>
											</v-avatar>
										</v-col>
									</v-row>
								</v-col>
								<v-col v-if="selectedRecord" cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid" :loading="loading" @click="insertRecord">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import { addBaseURL } from "@/utils/baseURL";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "المواضيع المثبتة",
					exact: true,
					to: { name: "dashboard-pinned" }
				},
				{
					text: "الإضافة",
					disabled: true
				}
			],
			loading: false,
			step: 1,
			recordID: 2,
			valid: false,
			title: "",
			description: "",
			cover: null,
			content: "",
			mediaTypes: [
				{ name: "دورة تدريبية", value: "course" },
				{ name: "خبر", value: "news" },
				{ name: "نقل ببديل", value: "replacement" },
				{ name: "فعالية", value: "event" },
				{ name: "وظيفة", value: "job" },
				{ name: "مكتبة طبية", value: "library" },
			],
			mediaType: null,
			selectedRecord: null,
			records: [],
			order: 1,
			orders: [1, 2, 3, 4, 5, 6]
		};
	},
	watch: {
		mediaType(newVal) {
			this.selectedRecord = null;
			this.records = [];
			console.log(newVal);
			if (newVal == "course") {
				this.getCourses();
			} else if (newVal == "news") {
				this.getNews();
			} else if (newVal == "event") {
				this.getEvents();
			} else if (newVal == "job") {
				this.getJobs();
			} else if (newVal == "library") {
				this.getLibrary();
			} else if (newVal == "replacement") {
				this.getReplacements();
			}
		}
	},
	mounted() {
		//
	},
	methods: {
		getCourses() {
			client
				.post("/api/courses/all", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.relatedModel = 'courses';
							record.relatedID = record.courseID;
							record.description = record.description || " ";
							var route = {
								name: "course",
								params: { courseID: record.courseID }
							};
							route = this.$router.matcher.match(route).fullPath;
							record.url = document.location.origin + route;
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getNews() {
			client
				.post("/api/news/all", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.relatedModel = 'news';
							record.relatedID = record.id;
							record.coverPic = addBaseURL(record.coverPic);

							var route = {
								name: "news-item",
								params: { recordID: record.id }
							};
							route = this.$router.matcher.match(route).fullPath;
							record.url = document.location.origin + route;
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getEvents() {
			client
				.post("/api/events/all", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.relatedModel = 'events';
							record.relatedID = record.eventID;
							record.coverPic = addBaseURL(record.coverPic);

							record.description = "";
							var route = {
								name: "event",
								params: { recordID: record.eventID }
							};
							route = this.$router.matcher.match(route).fullPath;
							record.url = document.location.origin + route;
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getJobs() {
			client
				.post("/api/jobs/all", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.relatedModel = 'jobs';
							record.relatedID = record.jobID;
							record.description = record.companyName || " ";
							var route = {
								name: "job",
								params: { jobID: record.jobID }
							};
							route = this.$router.matcher.match(route).fullPath;
							record.url = document.location.origin + route;
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getLibrary() {
			client
				.post("/api/library/all", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.relatedModel = 'library';
							record.relatedID = record.id;
							record.description = record.type || " ";
							
							var route = {
								name: "library-item",
								params: { recordID: record.id }
							};
							route = this.$router.matcher.match(route).fullPath;
							record.url = document.location.origin + route;
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getReplacements() {
			client
				.post("/api/replacements/all", { itemsPerPage: 99999 })
				.then(response => {
					console.log(response);
					this.records = Object.values(response.data.data.data).map(
						record => {
							record.relatedModel = 'replacements';
							record.relatedID = record.replacementID;
							record.description = record.toRegion || " ";
							record.coverPic = addBaseURL('/storage/logo.png');

							var route = {
								name: "replacement",
								params: { recordID: record.replacementID }
							};
							route = this.$router.matcher.match(route).fullPath;
							record.url = document.location.origin + route;
							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
		insertRecord() {
			this.loading = true;

			var data = new FormData();
			data.append("title", this.selectedRecord.title);
			if(this.selectedRecord.description && this.selectedRecord.description.trim()){
				data.append("description", this.selectedRecord.description);
			} else {
				data.append("description", '-');
			}
			var relativeCoverPic = this.selectedRecord.coverPic.replace('https://ertiqa.svod.app/storage/', '');
			data.append("coverPic", relativeCoverPic);
			data.append("url", this.selectedRecord.url);
			data.append("order", this.order);
			data.append("relatedModel", this.selectedRecord.relatedModel);
			data.append("relatedID", this.selectedRecord.relatedID);

			client
				.post("/api/pinTopic/insert", data)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ"
					});
					this.$router.push({ name: "dashboard-pinned-manage" });
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>
